import {Subject} from 'rxjs';

export class DashboardSectionOptions {
  private _changeSubject = new Subject<{ name: string, data: any }>();
  change$ = this._changeSubject.asObservable();

  title: string;

  change(name: string, data: any) {
    this._changeSubject.next({name, data});
  }
}
